import React from "react";
import classNames from "classnames";
import Modal from "ReactComponents/Modal/modal";
import IProductDeliveryInfo from "interfaces/IProductDeliveryInfo";

export interface IDeliveryCostsModalProps {
    productDeliveryInfo: IProductDeliveryInfo;
    isOpen: boolean;
    onClose: () => void;
}

const DeliveryCostsModal: React.FC<IDeliveryCostsModalProps> = ({
    productDeliveryInfo,
    isOpen,
    onClose
}: IDeliveryCostsModalProps) => {
    const baseClass = "delivery-costs-modal";
    const rootClasses = classNames(baseClass, "content-module");

    return (
        <Modal
            labelledBy="delivery-cost-modal-header"
            modalClassName={rootClasses}
            isOpen={isOpen}
            toClose={onClose}
            showCloseButton
        >
            <div className="delivery-costs-modal__content">
                <h2 id="delivery-cost-modal-header">{productDeliveryInfo.HeaderText}</h2>

                <div className="text" dangerouslySetInnerHTML={{ __html: productDeliveryInfo.BodyText }} />
            </div>
        </Modal>
    );
};

export default DeliveryCostsModal;
